import React from 'react'
import { FooterComponent } from './styled'

export const Footer = ({ children }) => {
	return <FooterComponent>{children}</FooterComponent>
}
